// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__2dWLA"};